import { render, staticRenderFns } from "./Alojamento.vue?vue&type=template&id=2b9256d0&scoped=true&"
import script from "./Alojamento.vue?vue&type=script&lang=js&"
export * from "./Alojamento.vue?vue&type=script&lang=js&"
import style0 from "./Alojamento.vue?vue&type=style&index=0&id=2b9256d0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9256d0",
  null
  
)

export default component.exports